module.exports = __webpack_public_path__ + "static/media/bass.b53322ef.mp3";